export default "__VITE_ASSET__CUlm60Mr__"